import { Button, Flex, Result, Spin } from 'antd';
import { Navigate, Outlet } from 'react-router';
import { isAdminRole } from '@titularis/api-client';
import { signOut, useSession } from './auth';

/**
 * Portão do backoffice: exige sessão e papel administrativo.
 *
 * Aluno autenticado que abrir o admin (o cookie é compartilhado entre os
 * subdomínios) vê uma recusa explícita, não uma tela em branco.
 */
export function RequireAdmin() {
  const { data, isPending } = useSession();

  if (isPending) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100dvh' }}>
        <Spin />
      </Flex>
    );
  }

  if (!data?.user) {
    return <Navigate to="/entrar" replace />;
  }

  if (!isAdminRole((data.user as { role?: string }).role)) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100dvh', padding: 16 }}>
        <Result
          status="403"
          title="Acesso restrito"
          subTitle="Esta área é do time do Titularis. Sua conta não tem acesso ao backoffice."
          extra={
            <Button type="primary" onClick={() => void signOut()}>
              Sair
            </Button>
          }
        />
      </Flex>
    );
  }

  return <Outlet />;
}

/**
 * Portão do que é do Dono: catálogo, preço e venda.
 *
 * **A recusa de verdade é da API** - as rotas de `/admin/products` exigem
 * `billing:manage` (G-POLICY), e nada aqui autoriza coisa alguma. O que este
 * guarda faz é não abrir uma tela que vai encher de erro: um administrador que
 * digitasse `/produtos` na barra veria quatro cartões vazios e um alerta
 * vermelho, o que parece defeito e é permissão.
 */
export function RequireOwner() {
  const { data, isPending } = useSession();

  if (isPending) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100dvh' }}>
        <Spin />
      </Flex>
    );
  }

  if ((data?.user as { role?: string } | undefined)?.role !== 'owner') {
    return (
      <Result
        status="403"
        title="Só o Dono"
        subTitle="Preço, produto e histórico de venda são do dono da operação. Peça a ele o que precisa mudar."
      />
    );
  }

  return <Outlet />;
}

export function RedirectIfAuthenticated() {
  const { data, isPending } = useSession();

  if (isPending) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100dvh' }}>
        <Spin />
      </Flex>
    );
  }

  return data?.user ? <Navigate to="/" replace /> : <Outlet />;
}
